
// Base height (px) for one hour-block in the card timeline
export const CARD_BASE_HEIGHT_PX = 136;

// Gap (px) between consecutive cards/slots in the point list flex container
export const CARD_GAP_PX = 16;

// Default grid start (fallback when the route has no start time) and fixed grid end.
// The actual grid start is dynamic per route (HRS-2640): see
// EditRouteService.routeStartHour / helpers/route-start-hour.ts.
export const START_TIME_HOUR = 10;
export const END_TIME_HOUR = 24;

// Hour labels of the timeline axis, from the route's start hour to midnight.
export const getDailyHours = (startHour: number = START_TIME_HOUR): string[] =>
  Array.from({ length: END_TIME_HOUR - startHour + 1 }, (_, i) => {
    const hour = i + startHour;
    return (hour === END_TIME_HOUR ? '00' : hour.toString().padStart(2, '0'));
  });
